'use client';

export { default } from './usePagination';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/usePagination/index.js
// module id = 561
// module chunks = 25